// import confetti from 'canvas-confetti';
// console.log('section - scripts/sections/header.js');
// confetti();
const desktop_menu_items = document.querySelectorAll('.navigation.desktop .main_menu > .menu__link > a');
const desktop_menu_subs = document.querySelectorAll('.navigation.desktop .dropdown_menu > .submenu');
desktop_menu_items.forEach(item => {
  item.addEventListener('mouseenter', e => {
    console.log(e);
    desktop_menu_items.forEach(allitem => {
      allitem.parentElement.classList.remove('active');
    });
    item.parentNode.classList.add('active');
  });
});
desktop_menu_subs.forEach(item => {
  item.classList.remove('lg:hidden');
  item.addEventListener('mouseleave', e => {
    e.target.parentNode.classList.remove('active');
  });
}); //Page width megamenu fix

let mega_menu_items = document.querySelectorAll('.navigation.desktop .mega_menu__container');
mega_menu_items.forEach(item => {
  const org_html = item.innerHTML;
  const new_html = "<div class='mega_menu__content__wrapper'>" + org_html + '</div>';
  item.innerHTML = new_html;
});
document.querySelector('.header-wrapper').addEventListener('mouseleave', e => {
  desktop_menu_items.forEach(item => {
    item.parentNode.classList.remove('active');
  });
});
